import uniq from 'lodash/uniq';
import compact from 'lodash/compact';
import {
  ProformaInvoiceFormGroupByMode,
  ProformaInvoiceFormViewMode
} from '../../ProformaInvoiceForm.types';
import { FetchGroupedItemsSortEnum } from '../../../../../../groupedItems/groupedItemsTypes';

function getSortFromViewMode(
  viewMode: ProformaInvoiceFormViewMode,
  groupByMode: ProformaInvoiceFormGroupByMode,
  enableGrouping: boolean,
  cacheApiEnabled?: boolean
) {
  const viewModeSort: FetchGroupedItemsSortEnum[] = [];
  const groupBySort: FetchGroupedItemsSortEnum[] = [];

  const projectValue = cacheApiEnabled
    ? FetchGroupedItemsSortEnum.ROOT_PROJECT_CREATED_AT_ASC
    : FetchGroupedItemsSortEnum.PROJECT_CREATED_AT_ASC;

  switch (viewMode) {
    case ProformaInvoiceFormViewMode.INVOICES:
      viewModeSort.push(FetchGroupedItemsSortEnum.ITEM_CREATED_AT_ASC);
      break;

    case ProformaInvoiceFormViewMode.TASKS:
      viewModeSort.push(FetchGroupedItemsSortEnum.TASK_CREATED_AT_ASC);
      break;

    case ProformaInvoiceFormViewMode.GROUPS:
      viewModeSort.push(FetchGroupedItemsSortEnum.PROJECT_CREATED_AT_ASC);
      break;

    case ProformaInvoiceFormViewMode.PROJECTS:
      viewModeSort.push(projectValue);
      break;

    case ProformaInvoiceFormViewMode.CATEGORIES:
      viewModeSort.push(FetchGroupedItemsSortEnum.CATEGORY_NAME_ASC);
      break;
  }

  if (!enableGrouping) {
    return uniq(compact(viewModeSort));
  }

  switch (groupByMode) {
    case ProformaInvoiceFormGroupByMode.TASK:
    case ProformaInvoiceFormGroupByMode.MONTH_TASK_CREATED_TASK:
    case ProformaInvoiceFormGroupByMode.MONTH_TASK_CREATED:
      groupBySort.push(FetchGroupedItemsSortEnum.TASK_CREATED_AT_ASC);
      break;

    case ProformaInvoiceFormGroupByMode.GROUP:
      // groupBy.add(GroupedItemsGroupByEnum.FIRST_SUBPROJECT);
      break;

    case ProformaInvoiceFormGroupByMode.PROJECT:
    case ProformaInvoiceFormGroupByMode.PROJECT_SPLIT:
    case ProformaInvoiceFormGroupByMode.MONTH_PROJECT_CREATED_PROJECT:
    case ProformaInvoiceFormGroupByMode.MONTH_PROJECT_CREATED:
      groupBySort.push(projectValue);
      break;

    case ProformaInvoiceFormGroupByMode.PROJECT_TASK:
    case ProformaInvoiceFormGroupByMode.PROJECT_GROUP_TASK:
      groupBySort.push(projectValue);
      groupBySort.push(FetchGroupedItemsSortEnum.TASK_CREATED_AT_ASC);
      break;

    case ProformaInvoiceFormGroupByMode.PROJECT_GROUP:
      groupBySort.push(projectValue);
      groupBySort.push(FetchGroupedItemsSortEnum.PROJECT_CREATED_AT_ASC);
      break;

    case ProformaInvoiceFormGroupByMode.GROUP_TASK:
      groupBySort.push(FetchGroupedItemsSortEnum.PROJECT_CREATED_AT_ASC);
      groupBySort.push(FetchGroupedItemsSortEnum.TASK_CREATED_AT_ASC);
      break;

    case ProformaInvoiceFormGroupByMode.BATCH:
      groupBySort.push(FetchGroupedItemsSortEnum.ITEM_CREATED_AT_ASC);
      break;

    case ProformaInvoiceFormGroupByMode.MONTH_INVOICE_CREATED:
      groupBySort.push(FetchGroupedItemsSortEnum.INVOICE_CREATION_MONTH_ASC);
      break;

    case ProformaInvoiceFormGroupByMode.BATCH_TASK:
      groupBySort.push(FetchGroupedItemsSortEnum.TASK_CREATED_AT_ASC);
      groupBySort.push(FetchGroupedItemsSortEnum.ITEM_CREATED_AT_ASC);
      break;

    case ProformaInvoiceFormGroupByMode.MONTH_TASK_DUE_DATE_TASK:
      groupBySort.push(FetchGroupedItemsSortEnum.TASK_DUE_DATE_MONTH_ASC);
      groupBySort.push(FetchGroupedItemsSortEnum.TASK_CREATED_AT_ASC);
      break;

    case ProformaInvoiceFormGroupByMode.MONTH_TASK_DUE_DATE:
      groupBySort.push(FetchGroupedItemsSortEnum.TASK_DUE_DATE_MONTH_ASC);
      break;

    case ProformaInvoiceFormGroupByMode.MONTH_PROJECT_CLOSED:
      groupBySort.push(
        cacheApiEnabled
          ? FetchGroupedItemsSortEnum.ROOT_PROJECT_CLOSURE_MONTH_ASC
          : FetchGroupedItemsSortEnum.PROJECT_CLOSURE_MONTH_ASC
      );
      break;

    case ProformaInvoiceFormGroupByMode.INVOICE_TAG:
      // groupBySort.push(FetchGroupedItemsSortEnum.INVOICE_TAG_ASC); // backend error
      break;
  }

  return uniq(compact([...groupBySort, ...viewModeSort]));
}

export default getSortFromViewMode;
